import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/admin';
import { useLocation } from 'react-router-dom';
import Breadcrumbs from '../../../components/elements/Breadcrumbs';
import { useMutation, useQuery } from '@tanstack/react-query';
import { getSearchConfig, postSearchConfig } from '../../../services/search';
import useLocalStorage from '../../../hooks/useUserData';
import SearchSection from '../../../components/fragments/SearchSection';
import { showNotification } from '../../../utilities/mantineNotification';
import PublicLayout from '../../../components/layout/PublicLayout';
import HelmetTitle from '../../../components/helmet_title/HelmetTitle';
import { Container } from '@mantine/core';

const DetailSearchUmumPage = (props) => {
  const [userData, setUserData] = useLocalStorage('persist:root', null);
  const [dataSearch, setDataSearch] = useState([]);
  const data = JSON.parse(userData?.auth);
  const location = useLocation();

  const queryParams: any = new URLSearchParams(location.search);

  const querytype = queryParams.get('type');
  const querysearch = queryParams.get('search');

  useEffect(() => {
    if (querysearch === '' || querysearch === null) {
      // go to home
      props.history.push('/s');
    } else {
    }
  }, [querysearch]);

  const [dataPayload, setDataPayload] = useState({
    type: querytype.toLowerCase(),
    limit: 0,
    isUmum: 'Y',
    course: {
      search: querysearch.toLowerCase()
    },
    content: {
      search: querysearch.toLowerCase(),
      category: null
    },
    personalwisdom: {
      search: querysearch.toLowerCase()
    },
    leaderwisdom: {
      search: querysearch.toLowerCase()
    },
    fns: {
      search: querysearch.toLowerCase()
    },
    testimony: {
      search: querysearch.toLowerCase()
    }
  });

  useEffect(() => {
    const dataTemp = {
      type: querytype.toLowerCase(),
      isUmum: 'Y',
      limit: 0,
      course: {
        search: querysearch.toLowerCase()
      },
      content: {
        search: querysearch.toLowerCase(),
        category: null
      },
      personalwisdom: {
        search: querysearch.toLowerCase()
      },
      leaderwisdom: {
        search: querysearch.toLowerCase()
      },
      fns: {
        search: querysearch.toLowerCase()
      },
      testimony: {
        search: querysearch.toLowerCase()
      }
    };
    setDataPayload(dataTemp);
  }, [querysearch]);

  useEffect(() => {
    fetchedSearchConfig.mutate(dataPayload);
  }, [dataPayload]);

  const fetchedSearchConfig = useMutation({
    mutationFn: postSearchConfig,
    onSuccess: () => {
      // console.log(data);
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  return (
    <PublicLayout titlePage="General Search" size="lg">
      <Container>
        <SearchSection
          pageSection={fetchedSearchConfig?.data?.data?.pageSection || []}
          loading={fetchedSearchConfig.isLoading}
          isError={fetchedSearchConfig.isError}
          isDetail={true}
        />
      </Container>
    </PublicLayout>
  );
};

export default DetailSearchUmumPage;
